import { combineReducers } from 'redux';
import { modalQueueSlice } from './queue/reducer';

export const modal = combineReducers({
  queue: modalQueueSlice.reducer,
});
